var common = require("../../utiles/common.js")
var layUtils = require("../../utiles/layUtils");
var metaTypeUtils = require("../../utiles/metaTypeUtils");
var metaService = require("../../services/metaService");

module.exports = {
    register: function () {
        document.createElement('reg')
        ko.components.register('reg', {
            viewModel: function (params) {
                var $this = this;
                $this.app = {
                    formId: common.urlSearch(window.location.href).formId,
                    actionId: common.urlSearch(window.location.href).actionId,
                    submitText: "注册",
                    callback:function(){
                        layUtils.confirm("注册成功,是否跳转登录?",function(){
                            common.redirectTo("/#/login");
                        })
                    }
                }
            },
            template: require("./Reg.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/reg/Reg.js
// module id = 172
// module chunks = 0